import React from "react"
import DesktopOnboardingForm from "../../components/Onboarding/onboarding-form"
import * as styles from "./on-demand-selector.module.less"

const OnDemandSelector = ({ close = () => null }) => {
  return (
    <div className={styles.on_demand_wrapper}>
      <div>
        <div className="container text-end">
          <button onClick={close} className={`btn ${styles.close_button}`}>
            <img src={require("../locations/close.svg").default} alt="" />
          </button>
        </div>

        <div className={styles.on_demand_body_wrapper}>
          <div className={"container"}>
            <h2>Reserve On-Demand Private Offices </h2>
            <DesktopOnboardingForm
              category={2}
              ulClass={styles.with_shadow}
              desktop
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default OnDemandSelector
